import { useRouteError, Link } from "react-router-dom";
import { Button, Result } from "antd";

const errorTypeMap = {
  404: {
    title: "页面不存在",
    subTitle: "您访问的页面可能已被删除或暂时不可用",
  },
  500: {
    title: "服务器开小差了",
    subTitle: "请稍后重试或联系技术支持",
  },
  default: {
    title: "未知错误发生",
    subTitle: "系统遇到意外错误，请尝试以下操作",
  },
};

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  // 获取错误类型
  const status = error?.status || error?.response?.status;
  const message = error?.data || error?.message;

  // 匹配错误类型
  const { title, subTitle } = errorTypeMap[status] || errorTypeMap.default;

  return (
    <div style={{ maxWidth: 800, margin: "100px auto" }}>
      <Result
        status={status === 404 ? "404" : "error"}
        title={title}
        subTitle={
          <>
            <p>{subTitle}</p>
            {message && (
              <div
                style={{
                  textAlign: "left",
                  background: "#f5f5f5",
                  padding: 16,
                }}
              >
                <code>{message}</code>
              </div>
            )}
          </>
        }
        extra={[
          <Button type="primary" key="home">
            <Link to="/">返回首页</Link>
          </Button>,
          status === 500 && (
            <Button key="retry" onClick={() => window.location.reload()}>
              重试页面
            </Button>
          ),
        ]}
      />
    </div>
  );
}
